import React from 'react';

import { useGGTheme } from 'hooks/theme/useGGTheme';

import { GenericError } from './GenericError';
import { NotFound } from './NotFound';

export function NotFoundContainer() {
  const {
    components: { MinimalLayout },
  } = useGGTheme();

  return (
    <MinimalLayout hideBackground>
      <NotFound />
    </MinimalLayout>
  );
}

export function GenericErrorContainer() {
  const {
    components: { MinimalLayout },
  } = useGGTheme();

  return (
    <MinimalLayout hideBackground>
      <GenericError />
    </MinimalLayout>
  );
}
